
import React from 'react'
import { Col, Row } from 'reactstrap';
import { FakeSelectData } from '../../Layout/app/Const';
import { useFormikContext } from 'formik';

import { DatePicker } from 'antd';
import ValidationField from '../../Components/ValidationField/ValidationField';

function FormRecentWorks() {
  const formik = useFormikContext<any>();



  return (
    <Row xs={1} sm={1} md={1} lg={2} xl={2}>
      <Col>
        {/* name from form utils */}
        <ValidationField name="title" type="text" label='title' placeholder='placeholder' />
        <ValidationField name="description" type="text" label='description' placeholder='placeholder' />

      </Col>
      <Col>
        <ValidationField name="image" type="File" label='image' placeholder='placeholder' />

      </Col>


    </Row>
  )
}

export default FormRecentWorks


